import { render, staticRenderFns } from "./ModalRichMenuTemplateSelection.vue?vue&type=template&id=59c617be&scoped=true&"
import script from "./ModalRichMenuTemplateSelection.vue?vue&type=script&lang=js&"
export * from "./ModalRichMenuTemplateSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModalRichMenuTemplateSelection.vue?vue&type=style&index=0&id=59c617be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c617be",
  null
  
)

export default component.exports